"use client"

import { extractProperty, replaceRichTextLinks } from "utils"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { JSX, useEffect } from "react"
import { useInView } from "react-intersection-observer"
import { AnimatedTypography } from "ui"
import Container from "ui/Container"
import {
  delayTime,
  transitionEase,
  transitionTime,
  useInViewConfig,
} from "ui/transitions/utils"

const OuterLayout = styled.div`
  width: 100%;
  display: flex;
`
const StyledLayout = styled.div<{ $inView: boolean; $paddingBottom?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 32px;
  padding-bottom: ${(p) => (p.$paddingBottom ? "24px" : "0")};
  opacity: ${(p) => (p.$inView ? 1 : 0)};
  transition: all ${transitionTime}s ${transitionEase};
  transform: ${(p) => (p.$inView ? "translateX(0px)" : `translateX(-100vw)`)};
  transition-delay: ${delayTime}s;
  ${(p) => p.theme.breakpoints.up("md")} {
    /* max-width: 700px; */
    gap: 24px;
    padding-top: 48px;
    padding-bottom: ${(p) => (p.$paddingBottom ? "48px" : "0")};
  }
`

const StyledTypography = styled(Typography)`
  p {
    margin: 0;
  }
`

export default function DynamicTitle({
  data,
  paddingBottom = true,
}: {
  data: any
  paddingBottom?: boolean
}): JSX.Element {
  const title = extractProperty(data, "title")
  const content = extractProperty(data, "content")
  const { ref, inView } = useInView({ ...useInViewConfig, threshold: 0 })
  useEffect(() => {
    console.log("[client] inView:", inView)
  }, [inView])
  return (
    <Container paddingMobile={true}>
      <OuterLayout ref={ref}>
        <StyledLayout $inView={inView} $paddingBottom={paddingBottom}>
          {title && (
            <AnimatedTypography variant="h2" component="h2" $inview={inView}>
              {title}
            </AnimatedTypography>
          )}
          {content && (
            <AnimatedTypography
              variant="body1"
              $inview={inView}
              component="div"
              dangerouslySetInnerHTML={{
                __html: replaceRichTextLinks(content),
              }}
            ></AnimatedTypography>
          )}
        </StyledLayout>
      </OuterLayout>
    </Container>
  )
}
